// extracted by mini-css-extract-plugin
module.exports = {"modal":"OrderConfigurationModal_modal__Eb8bd","minContent":"OrderConfigurationModal_minContent__xo9pE","fitContent":"OrderConfigurationModal_fitContent__RH62H"};